import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import "./App.css";
import ROUTE_PATHS from "./utils/routePaths";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./utils/theme";
import WelcomeScreen from "./screens/Welcome Screen/WelcomeScreen";
import SigninScreen from "./screens/Signin Screen/SigninScreen";
import InitialLoadScreen from "./screens/Initial Load Screen/InitialLoadScreen";
import { TabBarProvider } from "services/TabBarProvider";
import HomeScreen from "screens/Home Screen/HomeScreen";
import ReservationsScreen from "screens/Reservations Screen/ReservationsScreen";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TabBarProvider>
        <Router>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<WelcomeScreen />} />
            <Route path={ROUTE_PATHS.WSM_SIGNIN} element={<SigninScreen />} />
            <Route
              path={ROUTE_PATHS.WSM_INITIAL_LOAD}
              element={<InitialLoadScreen />}
            />
            <Route path={ROUTE_PATHS.WSM_HOME} element={<HomeScreen />} />
            <Route
              path={ROUTE_PATHS.WSM_RESERVATIONS}
              element={<ReservationsScreen />}
            />
          </Routes>
        </Router>
      </TabBarProvider>
    </ThemeProvider>
  );
};

export default App;
